import { useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { QRCodeCanvas } from 'qrcode.react';

import Button from '../Button';

const SharingQrCode = ({ boardUrl, boardName }) => {
  const { t } = useTranslation('boardSetup');
  const [href, setHref] = useState('');

  const canvasRef = useRef();

  useEffect(() => {
    const generateHref = () => {
      if (!canvasRef.current) return '';

      const canvas = canvasRef.current;
      return canvas.toDataURL('image/png');
    };
    setHref(generateHref());
  }, [canvasRef]);

  return (
    <QrCodeSection>
      <QrCodeWrapper>
        <QRCodeCanvas ref={canvasRef} marginSize={4} value={boardUrl} />
      </QrCodeWrapper>
      <Button
        height="auto"
        mode="outline"
        variant="primary"
        padding="5px 10px"
        href={href}
        download={`${boardName} QR Code.png`}
        as="a"
      >
        {t('downloadQRCode')}
      </Button>
    </QrCodeSection>
  );
};

export default SharingQrCode;

const QrCodeSection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 25px;
  min-width: 166px;
  height: auto;
`;

const QrCodeWrapper = styled.div`
  border: 1px solid black;
  border-radius: 8px;
  padding: 2px;
  display: none;
`;
